module.exports = __webpack_public_path__ + "img/IMG_1347.dfce1fac.png";